module.exports = __webpack_public_path__ + "static/series_2110-4d8dea99465265e43455d7fa93a78c27.png";